import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { LocalStorageService } from "src/app/utils/localstorage.service";
import { environment } from "../../../../../environments/environment";
import { Observable, Subject } from "rxjs";

@Injectable()
export class WelcomeService {
  constructor(private http: HttpClient) {}

  getWelcomePage(): Promise<any> {
    return this.http.get(`${environment.apiUrl}/welcome/`).toPromise();
  }

  saveWelcomePage(content): Promise<any> {
    return this.http
      .patch(`${environment.apiUrl}/welcome/`, { content })
      .toPromise();
  }

  public welcomeToolbarSettings: Object = {
    type: "MultiRow",
    items: [
      "alignments",
      "justifyLeft",
      "justifyCenter",
      "justifyRight",
      "justifyFull",
      "fontName",
      "fontSize",
      "fontColor",
      "backgroundColor",
      "bold",
      "italic",
      "underline",
      "|",
      "strikeThrough",
      "clearFormat",
      "clearAll",
      "cut",
      "copy",
      "paste",
      "unorderedList",
      "orderedList",
      "indent",
      "outdent",
      "undo",
      "redo",
      "|",
      "superScript",
      "subScript",
      "createLink",
      "openLink",
      "editLink",
      "image",
      "createTable",
      "removeTable",
      "replace",
      "|",
      "align",
      "caption",
      "remove",
      "openImageLink",
      "insertLink",
      "display",
      "altText",
      "dimension",
      "|",
      "fullScreen",
      "maximize",
      "minimize",
      "|",
      "lowerCase",
      "upperCase",
      "print",
      "formats",
      "sourceCode",
      "preview",
      "viewSide",
      "|",
      "insertCode",
      "tableHeader",
      "tableRemove",
      "tableRows",
      "tableColumns",
      "|",
      "tableCellBackground",
      "tableCellHorizontalAlign",
      "tableCellVerticalAlign",
      "tableEditProperties",
      "styles",
      "removeLink",
    ],
  };
}
